angular.module('sorting', ['core', 'clients', 'currency'])
    .factory('Sorting', function ($resource) {
        return $resource('/crm/api/sorting/:id/:action', {id: '@id', action: '@action'}, {
            list: {method: 'GET', isArray: false},
            update: {method: 'PUT'},
            deduct: {method: 'POST', params: {action: 'deduct'}},
            remove: {method: 'DELETE'}
        });
    })
    .factory('SortingSize', function ($resource) {
        return $resource('/crm/api/sorting/sizes', {}, {
            list: {method: 'GET', isArray: true}
        });
    })
    .service('SortingService', function ($rootScope, toastr, modals, Sorting) {
        this.editModal = entry => {
            return modals.open('app/egg/sorting/entry-modal.tpl.html', 'SortingEntryEditController', {entry: entry});
        };
        this.deduct = (entry, deducted) => {
            let content = `Czy chcesz zmienić stan odliczenia dokumentu <b>${entry.pod}</b>?`;
            modals.confirm(content, () => new Sorting(entry).$deduct({deducted: deducted}, result => $rootScope.$broadcast('sorting.updated', result)));
        };

        this.remove = entry => {
            return modals.confirmDelete(entry.pod, () => new Sorting(entry).$delete({id: entry.id}, () => $rootScope.$broadcast('sorting.updated')).$promise);
        };

        this.settingsModal = settings => {
            return modals.open('app/egg/sorting/settings-modal.tpl.html', 'SortingSettingsController', {item: settings}, {size: 'lg'});
        };
    })
    .controller('SortingListController', function ($scope, page, $state, $stateParams, Sorting, SortingSize, SortingService, Principal, UrlBuilder, ModuleSettings) {
        var vm = this;
        vm.filters = angular.copy($stateParams);
        vm.page = page;
        vm.sizes = SortingSize.list();
        vm.settings = ModuleSettings.get({module: "sorting"});

        vm.reset = () => vm.filters = {};
        vm.add = () => SortingService.editModal({
            date: moment().subtract(1, 'days').format('YYYY-MM-DD'),
            toDeduct: 0
        });
        vm.canDeduct = () => Principal.hasAnyAuthority(["ROLE_ADMIN", "ROLE_MODULE_SORTING_DEDUCT"]);
        vm.deduct = (entry, deducted) => SortingService.deduct(entry, deducted);
        vm.canEdit = () => Principal.hasAnyAuthority(["ROLE_ADMIN", "ROLE_MODULE_SORTING_EDIT"]);
        vm.edit = entry => SortingService.editModal(new Sorting(entry));
        vm.remove = entry => SortingService.remove(entry);
        vm.getReportLink = () => UrlBuilder.build("/crm/api/reporting/modules/sorting", $stateParams);

        vm.openSettingsModal = () => SortingService.settingsModal(vm.settings).then(newSettings => vm.settings = newSettings);
        $scope.$on('sorting.updated', () => $state.reload());
    })
    .controller('SortingEntryEditController', function ($scope, $rootScope, $uibModalInstance, data, toastr, Sorting, Client, SortingSize, Currency) {
        $scope.item = data.entry;
        $scope.sizes = SortingSize.list();
        Currency.query().$promise.then(items => {
            $scope.currencies = items;
            if ($scope.item.id == null) {
                $scope.item.currency = Currency.getDefault(items);
            }
        });

        $scope.cancel = () => $uibModalInstance.dismiss('Canceled');

        $scope.save = item => {
            let $promise
            if (angular.isNumber(item.id)) {
                $promise = Sorting.update(item).$promise
            } else {
                $promise = Sorting.save(item).$promise
            }
            return $promise
                .then(saved => {
                    $rootScope.$broadcast('sorting.updated', saved);
                    $uibModalInstance.close(saved)
                    toastr.success("Zapisano")
                })
        };

        $scope.refreshClients = q => Client.autocomplete({q: q}).$promise.then(items => $scope.clients = items)
    })
    .controller('SortingSettingsController', function ($scope, $rootScope, $uibModalInstance, data, toastr, ModuleSettings) {
        $scope.item = data.item;
        $scope.cancel = () => $uibModalInstance.dismiss('Canceled');

        $scope.save = item => {
            $scope.isSaving = true;
            return ModuleSettings.save({module: "sorting"}, item, saved => {
                $scope.isSaving = false;
                toastr.success("Zapisano ustawienia");
                $uibModalInstance.close(saved);
            });
        }
    })
    .run(function (NavbarLeftMenu) {
        NavbarLeftMenu.add({
            authorities: "ROLE_MODULE_SORTING",
            path: "/sorting",
            ico: "fa fa-fw fa-database",
            name: 'sorting.menu',
            order: 80
        });
    })
    .config(function ($stateProvider) {
        $stateProvider.state('eggSortingList', {
            parent: 'app',
            url: '/sorting?{page:int}&{size:int}&sort&search&periodStart&periodEnd&{supplier:int}&weightClass&{underClassFrom:number}&{underClassTo:number}&{brokenFrom:number}&{brokenTo:number}&{spoutedFrom:number}&{spoutedTo:number}&{dirtyFrom:number}&{dirtyTo:number}',
            data: {
                authorities: ['ROLE_MODULE_SORTING']
            },
            views: {
                'content@': {
                    templateUrl: 'app/egg/sorting/list.tpl.html',
                    controller: 'SortingListController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                page: (Sorting, $stateParams) => Sorting.list(angular.copy($stateParams)).$promise
            }
        });
    });
